const Statistics = ({ width = 22, height = 22, color = 'currentColor', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0.543C9.33 0.514 9.663 0.5 10 0.5C16.351 0.5 21.5 5.649 21.5 12C21.5 12.337 21.486 12.67 21.457 13H19.951C19.449 18.053 15.185 22 10 22C4.477 22 0 17.523 0 12C0 6.815 3.947 2.551 9 2.05V0.542V0.543ZM9 13V4.062C6.98271 4.31868 5.13885 5.33387 3.84319 6.90122C2.54752 8.46857 1.89728 10.4705 2.02462 12.5C2.15196 14.5296 3.04733 16.4345 4.52874 17.8276C6.01016 19.2207 7.96645 19.9975 10 20C11.9486 20 13.8302 19.2888 15.2917 18C16.7533 16.7112 17.6942 14.9333 17.938 13H9ZM19.448 11C19.2187 8.8379 18.255 6.81979 16.7176 5.28239C15.1802 3.74498 13.1621 2.78126 11 2.552V11H19.448Z"
        fill={color}
      />
    </svg>
  )
}

export default Statistics
